/**
 * Virtru Email Protection — email encryption for Gmail / Google Workspace
 *
 * Declares two WAR groups with no `use_dynamic_url`, globbing `js/*`, `css/*`, `fonts/*`,
 * `images/*` and `icons/*`. Both are matched only to Google origins — mail.google.com for
 * the first, vault/ediscovery for the second — so the resources are unreachable from any
 * other origin. A negative result off those sites proves nothing; this is only detectable
 * while running on Gmail.
 *
 * Manifest verified against version 12.7.16.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'nemmanchfojaehgkbgcfmdiidbopakpp';

export const virtruEmailProtection: ExtensionDefinition = {
  id: ID,
  name: 'Virtru Email Protection',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  requiredOrigin: 'https://mail.google.com',
  notes:
    'All WAR scoped to Google origins, no dynamic URL. Detectable only from ' +
    'mail.google.com; the gmail content script fetch is conclusive there.',
  signals: [
    {
      id: 'war-gmail-content-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/gmail-content.js — the Gmail content script, exposed only to ' +
        'mail.google.com.',
      weight: 1,
      run: () => probeFetch(ID, 'js/gmail-content.js'),
    },
    {
      id: 'war-virtru-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch css/virtru.css — the vendor-named stylesheet, a second scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/virtru.css'),
    },
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description: 'Fetch icons/icon-128.png — the extension icon, an independent scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'icons/icon-128.png'),
    },
  ],
};
